import React from 'react';
import { withRouter } from 'react-router-dom';
import * as core from 'cw-ui-core';
import css from './FramedScreen.scss';

class FramedScreen extends React.Component {
  constructor(props) {
    super(props);

    this.onMessage = this.onMessageFunc.bind(this); // THIS MUST BE DONE in order for THIS to work correctly
  }

  onMessageFunc = (event) => {
    // skip messages not from iframe and empty messages
    if (!event.data || event.origin !== core.getDomainFromUrl(this.props.src)) {
      return;
    }

    switch (event.data.type) {
      case 'navigate':
        const url = event.data.url;
        if (!url) {
          return;
        }

        // handle absolute urls
        if (url.startsWith('http://') || url.startsWith('https://')) {
          window.location.href = url;
          return;
        }

        // handle relative urls
        this.props.onShowMenuChanged(true); // reset shell on new navigations spawned from iframe
        this.props.history.push(event.data.url);
        break;
      case 'logout':
        core.userManager().signoutRedirect();
        break;
      case 'menuVisibility':
        const showMenu = event.data.showMenu;
        this.props.onShowMenuChanged(showMenu);
        break;
      case 'updateQueryParams':
        const params = event.data.params;
        const replace = event.data.replace;
        const path = window.location.pathname + params;
        if (replace) {
          this.props.history.replace(path);
        }
        else {
          this.props.history.push(path);
        }
        break;
      default:
        break;
    }
  }

  sendMessage = (msg) => {
    this.iframe.contentWindow.postMessage(msg, this.props.src);
  }

  componentDidMount() {
    window.addEventListener("message", this.onMessage, false);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.onMessage, false);
  }

  render() {
    let src = this.props.src;
    if (this.props.match.params.id) {
      src += '/' + this.props.match.params.id;
    }
    if (this.props.search) {
      src += this.props.search;
    }
    return (
      <iframe ref={iframe => this.iframe = iframe} className={css.frame} src={src} allow="geolocation" />
    );
  }
};

export default withRouter(FramedScreen);


// WEBPACK FOOTER //
// ./src/components/FramedScreen/FramedScreen.jsx